import { getApprovedCountries } from '~/helpers/orchestration/approvedCountries';
import { getUnlabelledCountryCodes } from '~/helpers/countries';
import { log } from '~/helpers/bugsnagHelper';
import { isAxiosError, isNetworkError } from '~/helpers/axiosUtils';
import { ReduxDispatch } from '../interfaces/Redux';
import { ReduxStore } from '../interfaces/store';
import { approvedCountriesStatusSelector } from '../selectors/approvedCountries';

const getApprovedCountriesRequest = () => ({
  type: 'GET_APPROVED_COUNTRIES_REQUEST' as const
});

const getApprovedCountriesSuccess = (payload: string[]) => ({
  type: 'GET_APPROVED_COUNTRIES_SUCCESS' as const,
  payload
});

const getApprovedCountriesFailure = () => ({
  type: 'GET_APPROVED_COUNTRIES_FAILURE' as const
});

export type ApprovedCountriesAction =
  | ReturnType<typeof getApprovedCountriesRequest>
  | ReturnType<typeof getApprovedCountriesSuccess>
  | ReturnType<typeof getApprovedCountriesFailure>;

const warnAboutUnlabelledCountries = (codes: string[]) => {
  const unlabelledCountryCodes = getUnlabelledCountryCodes(codes);
  if (unlabelledCountryCodes.length > 0) {
    log(new Error('Approved countries without a country label'), {
      severity: 'warning',
      unlabelledCountryCodes
    });
  }
};

export const fetchApprovedCountries =
  () => async (dispatch: ReduxDispatch, getState: () => ReduxStore) => {
    const status = approvedCountriesStatusSelector(getState());
    if (status === 'pending' || status === 'success') {
      return;
    }

    dispatch(getApprovedCountriesRequest());

    try {
      const codes = await getApprovedCountries();
      warnAboutUnlabelledCountries(codes);
      dispatch(getApprovedCountriesSuccess(codes));
    } catch (error) {
      const isNetworkFailure = isAxiosError(error) && isNetworkError(error);
      log(error, { severity: isNetworkFailure ? 'warning' : 'error' });
      dispatch(getApprovedCountriesFailure());
    }
  };
